// @flow

export const GLOBAL_APP_COUNT = '1,000';
